import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PrintErrorGuardService {
  private _printedErrors = new Map<string, number>();
  private readonly BLOCK_DURATION_MS = 60000; // 60 segundos

  /**
   * Verifica si se puede imprimir el error.
   * @param errorKey Clave única del error (id-pnr-msg)
   * @returns true si se puede imprimir, false si está bloqueado
   */
  // CWE-20 - Validación de input
  canPrint(errorKey: string): boolean {
    // CWE-20 - Sanitizar y validar input
    const sanitizedKey = this.sanitizeKey(errorKey);
    if (!sanitizedKey) {
      return false;
    }
    const lastPrintTime = this._printedErrors.get(sanitizedKey);

    if (!lastPrintTime) {
      return true;
    }

    const elapsed = Date.now() - lastPrintTime;

    if (elapsed > this.BLOCK_DURATION_MS) {
      this._printedErrors.delete(sanitizedKey);
      return true;
    }

    return false;
  }

  /**
   * Marca el error como impreso.
   * @param errorKey Clave única del error
   */
  markAsPrinted(errorKey: string): void {
    // CWE-20 - Sanitizar input
    const sanitizedKey = this.sanitizeKey(errorKey);
    if (sanitizedKey) {
      this._printedErrors.set(sanitizedKey, Date.now());
    }
  }

  // CWE-20 - Improper Input Validation
  // Sanitiza el errorKey eliminando caracteres que podrían formar URLs o inyecciones
  private sanitizeKey(key: string): string {
    if (!key || typeof key !== 'string') {
      return '';
    }
    if (key.includes('://') || key.includes('www.')) {
      return '';
    }
    return key.replace(/[^a-zA-Z0-9\-_.]/g, '');
  }

  reset(): void {
    this._printedErrors.clear();
  }
}
